import React, { FC } from 'react'

import { css } from 'styled-components'

import { WithDataName } from 'common/types'
import { SharingType } from 'components/block/SharingContent/SharingContent.constant'
import { ShareButton } from 'components/presentational/button/ShareButton'
import { DarkLight } from 'components/presentational/theme/DarkLight'

export const PhotoViewerShareButton: FC<
  {
    profileId: string
    photoId: number
  } & DarkLight &
    WithDataName
> = ({ profileId, photoId, dark, ...rest }) => {
  return (
    <ShareButton
      type={SharingType.profilePhoto}
      contentId={photoId}
      profileId={profileId}
      alignmentStyle={photoViewerAlignmentStyleCss}
      dark={dark}
      data-name={rest['data-name']}
    />
  )
}

export const photoViewerAlignmentStyleCss = css`
  ${(props) => props.theme.right}: 0;

  bottom: 0;
`
